import api from './axiosInstance';

export const getPlotsApi = (params) => api.get('/plots', { params });
export const createPlotApi = (data) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.parent_id ?? user?.id;
    return api.post('/add-plot', data, { headers: { user_id: userId } });
  } catch {
    return api.post('/add-plot', data);
  }
};
export const deletePlotApi = (id) => api.delete('/plots', { data: { id } });
export const getCropsByPlotIdApi = (plotId) => api.get(`/plot-crops/${plotId}`);
export const getCropsApi = (params) => api.get('/user/crops', { params });
export const getAllCropsApi = (params) => api.get('/user/all-crops', { params });
export const getCropNamesApi = (params) => api.get('/crop-names', { params });
export const getCropByIdApi = (params) => api.get('/crop-by-id', { params });
export const createCropApi = (data) => api.post('/user/create-crop', data);
export const updateCropApi = (data) => api.post('/update-crop', data);
export const deleteCropApi = (data) => api.delete('/delete-crop', { data });
export const changeCropStatusApi = (params) => api.get('/change-status', { params });
export const getExpenseSellingApi = (params) => api.get('/expense-selling', { params });
export const getFarmListApi = () => api.get('/user/farm-list');
export const getCropStagesApi = (params) => api.get('/crop-stages', { params });
export const getCropListFilterApi = (params) => api.get('/get-crop-list-filter', { params });
